import { create } from 'zustand';

type Phase = 'closed' | 'step1' | 'step2';

interface State {
  phase: Phase;
  submitting: boolean;
  open: () => void;
  toStep2: () => void;
  close: () => void;
  setSubmitting: (v: boolean) => void;
}

/**
 * 强平交互的多组件共享状态。
 *
 * 触发器(顶栏 / 仪表板 / FAB / 资金账户大屏)调用 open() → step1。
 * Step1 [继续] → toStep2() → step2。
 * Step2 提交 → adminEmergency.forceLiquidation → close() + 关闭弹窗,
 * 由 system 频道推送的 force_liquidation_started/progress/completed 接管 UI。
 */
export const useForceLiquidateStore = create<State>((set) => ({
  phase: 'closed',
  submitting: false,
  open: () => set({ phase: 'step1' }),
  toStep2: () => set({ phase: 'step2' }),
  close: () => set({ phase: 'closed', submitting: false }),
  setSubmitting: (submitting) => set({ submitting }),
}));
